import { useEffect } from "react";
import {
  DRIVER_PLANNING_UPDATED_EVENT,
  DRIVER_PLANNING_UPDATED_STORAGE_KEY,
} from "@/utils/driverPlanningEvents";

export function useDriverPlanningUpdates(onPlanningUpdated: () => void): void {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const customEventHandler = () => onPlanningUpdated();
    const storageEventHandler = (event: StorageEvent) => {
      if (event.key === DRIVER_PLANNING_UPDATED_STORAGE_KEY) {
        onPlanningUpdated();
      }
    };
    window.addEventListener(DRIVER_PLANNING_UPDATED_EVENT, customEventHandler);
    window.addEventListener("storage", storageEventHandler);
    return () => {
      window.removeEventListener(DRIVER_PLANNING_UPDATED_EVENT, customEventHandler);
      window.removeEventListener("storage", storageEventHandler);
    };
  }, [onPlanningUpdated]);
}

